export const WHITE = '#ffffff';
export const BLACK = '#000000';

export function hexToRgb(hex: string): RgbColor {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
}

export function rgbToHex(rgb: RgbColor, hashtag: boolean = true): string {
	let hex = '';
	for (const rgbVal of rgb) {
		const rgbStringVal = rgbVal.toString(16);
		hex += rgbStringVal.length === 1 ? '0' + rgbStringVal : rgbStringVal;
	}
	return (hashtag ? '#' : '') + hex;
}

export function mix(hex1: string, hex2: string, ratio: number = 0.5): string {
	const rgb1 = hexToRgb(hex1);
	const rgb2 = hexToRgb(hex2);

	const rgbMix = <RgbColor>rgb1.map((rgb1Val, i) => {
		return Math.ceil(rgb1Val * ratio + rgb2[i] * (1 - ratio));
	});

	return rgbToHex(rgbMix);
}

export function shade(hex: string, ratio: number): string {
	return mix('#000000', hex, ratio);
}

export function tint(hex: string, ratio: number): string {
	return mix('#ffffff', hex, ratio);
}

export function contrast(hex: string, dark = BLACK, light = WHITE): string {
	const rgb = hexToRgb(hex);

	// https://stackoverflow.com/a/3943023/112731
	return rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114 > 186 ? dark : light;
}

export function isLight(hex: string): boolean {
	return contrast(hex) === BLACK;
}

type RgbColor = [number, number, number];
